<template>
    <div class="instruction">
        <template v-if="item.params.image">
            <img :src="item.params.image" />
        </template>
    </div>
</template>

<script>

    export default {

        components: {},

        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        computed: {},

        methods: {},
    };
</script>
